'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconClockTriangle, iconClockTriangleTag } from '@ni/nimble-components/dist/esm/icons/clock-triangle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconClockTriangle };
export { iconClockTriangleTag };
export const NimbleIconClockTriangle = wrap(IconClockTriangle);